<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  export default{
  mounted(){
      // localStorage.setItem("openId",'osyLxspnCq_iMxrMvPlW7tgx-PTg')
      localStorage.removeItem("openId")
    if(localStorage.getItem("openId")){
      let dt = new URLSearchParams()
      dt.append('openid',localStorage.getItem("openId"))
      this.$http.post('/sangto-wrm/vip/member/getByOpenId',dt).then(({data})=>{ //使用openid获取会员信息
        if(data.code == 200 && data.data != null){
          // console.log(data.data)
          let dataStr = JSON.stringify(data.data)
          if(data.data.cardAccount){
            localStorage.setItem("login", '1')
          }else{
            localStorage.setItem("login", '0')
          }

          localStorage.setItem("userData", dataStr)
        }else{
          this.UI.Toast.failed(data.message)
        }
      })
    }else{
      let dtcode = new URLSearchParams()
      dtcode.append('code', window.MyCode)
      this.$http.post('/sangto-wrm/vip/member/getByCode',dtcode).then(({data})=>{
        // console.log(JSON.stringify(data.data))
        let openid = data.data.openid
        // let openid = 'osyLxsgbhd6D7oyVgEHS9ar-4Nfk'
        localStorage.setItem("code", JSON.stringify(data.data))
        localStorage.setItem("openId", openid) //保存openid
        // console.log(data.data.member)
        if(data.data.member){
          localStorage.setItem("login", '1')
        }else{
          localStorage.setItem("login", '0')
        }
        let dt = new URLSearchParams()
        dt.append('openid',openid)
        this.$http.post('/sangto-wrm/vip/member/getByOpenId',dt).then(({data})=>{ //使用openid获取会员信息
          if(data.code == 200 && data.data != null){
            // console.log(data.data)
            let dataStr = JSON.stringify(data.data)
            if(data.data.cardAccount){
              localStorage.setItem("login", '1')
            }else{
              localStorage.setItem("login", '0')
            }

            localStorage.setItem("userData", dataStr)
          }else{
            this.UI.Toast.failed(data.message)
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" >
#app{
  height: 100vh;
  position: relative;
  background: #f5f5f5;
}
</style>
